import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleCastService, PlaybackSession } from '@tytapp/media-playback';
import { PageComponent, PageService, Shell } from '@tytapp/common';
import { PlayerComponent } from '@tytapp/media-playback';
import { UserService } from 'user';

/// <reference path="../../../local-typings/cast.d.ts" />

@Component({
  selector: 'tyt-cast-receiver',
  templateUrl: './cast-receiver.component.html',
  styleUrls: ['./cast-receiver.component.scss']
})
export class CastReceiverComponent extends PageComponent implements OnInit {

  constructor(
    pageService : PageService,
    private googleCastService: GoogleCastService,
    private userService : UserService
  ) {
    super(pageService)
  }

  @ViewChild('player', { static: true })
  player : PlayerComponent;

  get user() {
    return this.userService.user;
  }

  get userDisplayName() {
    if (!this.user)
      return null;
    
    if (!this.user.profile)
      return null;
    
    if (this.user.profile.display_name)
      return this.user.profile.display_name;
    
    if (this.user.profile.first_name)
      return this.user.profile.first_name;
    
    if (this.user.display_name)
      return this.user.display_name;

    return null;
  }

  get isAudioOnly() {
    let session = this.player.getCurrentPlaybackSession();

    if (!session)
      return false;

    return session.mediaElement instanceof HTMLAudioElement;
  }

  get active() {
    return this.player.hasSession;
  }

  get paywalled() {
    return this.googleCastService.paywalled;
  }

  get mediaTitle() {
    return this.googleCastService.mediaTitle;
  }

  get mediaShowName() {
    return this.googleCastService.mediaShowName;
  }

  get mediaIsLive() {
    return this.googleCastService.mediaIsLive;
  }

  get mediaThumbnail() {
    return this.googleCastService.mediaThumbnail;
  }

  firstMediaLoaded : boolean = false;
  get loading() {

    return !this.firstMediaLoaded || this.googleCastService.loadingNewMedia;
  }

  ambientImage : string;

  get backgroundImage() {
    return this.mediaThumbnail || this.ambientImage;
  }

  sessionChanged(session : PlaybackSession) {
    this.firstMediaLoaded = true;
    this.googleCastService.player.attachToSession(this.player, session);
  }

  get isPlaying() {
    return this.player.hasSession;
  }

  endSession() {
    this.player.stopPlaying();
  }

  async init() {
    let backgrounds = [
      '/assets/flag-backdrop.png',
      '/assets/offer_bg_short.png'
    ];
    let currentBackground = 0;
    this.ambientImage = backgrounds[currentBackground];

    if (typeof window !== 'undefined') {
      setTimeout(() => this.firstMediaLoaded = true, 20*1000);
      setInterval(() => {
        if (this.isPlaying)
          return;
        
        currentBackground = (currentBackground + 1) % backgrounds.length;
        this.ambientImage = backgrounds[currentBackground];
      }, 10*1000);
    }
    
    this.shell.noLayout = true;
    await this.googleCastService.initializeReceiver(this.player);
  }
}
